import { render, staticRenderFns } from "./news-editor.vue?vue&type=template&id=2f2da59e&scoped=true&"
import script from "./news-editor.vue?vue&type=script&lang=ts&"
export * from "./news-editor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2da59e",
  null
  
)

export default component.exports